// extracted by mini-css-extract-plugin
export var camp = "index-module--camp--e5c07";
export var campBody = "index-module--campBody--d48d8";
export var campDesc = "index-module--campDesc--69368";
export var campDescText = "index-module--campDescText--db9cf";
export var campIcons = "index-module--campIcons--5d895";
export var campIconsIcon = "index-module--campIconsIcon--50f1b";
export var campImage = "index-module--campImage--1ffd0";
export var campImageWrapper = "index-module--campImageWrapper--a9597";
export var campTitle = "index-module--campTitle--4fea9";
export var fullText = "index-module--fullText--99a06";
export var jazzooDesc = "index-module--jazzooDesc--e114d";